const ITEMS = [
  "React",
  "Next.js",
  "AI Agents",
  "LLM Integration",
  "3D Printing",
  "Arduino",
  "Raspberry Pi",
  "Node.js",
  "Computer Vision",
  "SaaS",
  "Web Apps",
  "Custom Hardware",
  "Edge AI",
  "FastAPI",
  "Python",
  "IoT Systems",
  "Mobile Apps",
  "ESP32",
  "Fusion 360",
  "FDM / SLA",
  "Embedded C",
  "RAG Pipelines",
  "Cloud Infra",
  "TypeScript",
  "Sensor Fusion",
  "PCB Design",
  "OpenAI",
  "LangChain",
  "Docker",
  "AWS",
];

export default function Marquee() {
  return (
    <section
      className="relative py-10 border-y border-white/5 bg-ink-50/40"
      data-testid="marquee-section"
      aria-label="Technologies and capabilities"
    >
      <div className="marquee-mask overflow-hidden">
        <div className="flex gap-12 w-max animate-marquee">
          {[...ITEMS, ...ITEMS].map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-12 font-mono text-xs md:text-sm uppercase tracking-[0.2em] text-zinc-500 whitespace-nowrap"
            >
              <span className="h-1 w-1 rounded-full bg-accent-cyan/60" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
